export default __webpack_public_path__ + "static/media/data-report-animate.9195c241.svg";